import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../components/layout/SiteShell";
import ContentPageLayout from "../components/content/ContentPageLayout";
import SEO from "../components/seo/SEO";
import WellnessDisclaimer from "../components/content/WellnessDisclaimer";
import { COMMUNITY_REWARD, COMMUNITY_REWARD_STEPS } from "../lib/communityReward";
import { HOME_CTA_DARK_OUTLINE, HOME_CTA_DARK_PRIMARY } from "../lib/homeCta";

export default function CommunityRewardPage() {
  const r = COMMUNITY_REWARD;

  return (
    <SiteShell theme="dark">
      <SEO
        title="Routine Reward | Moss Matrix"
        description="Stay consistent. Get rewarded. Order three times on MossMatrix.com and receive a free plain 300ml Gold Sea Moss Gel with your next paid order. UK only."
        path="/community-reward"
      />
      <ContentPageLayout eyebrow={r.shortTitle} title="Stay consistent. Get rewarded." subtitle={r.headline}>
        <div className="max-w-2xl space-y-8 mb-12 font-sans">
          <section>
            <h2 className="font-sans font-semibold text-xl text-ivory m-0">How it works</h2>
            <ul className="mt-4 space-y-2 list-none p-0 m-0">
              {COMMUNITY_REWARD_STEPS.map((step) => (
                <li
                  key={step.n}
                  className={`rounded-xl border px-4 py-3 text-sm leading-snug ${
                    step.unlock
                      ? "border-gold/40 bg-gold/10 text-ivory"
                      : "border-white/12 bg-panel/80 text-sage"
                  }`}
                >
                  {step.label}
                </li>
              ))}
            </ul>
            <p className="mt-4 text-sm text-sage leading-relaxed m-0">{r.offer}</p>
          </section>

          <section>
            <h2 className="font-sans font-semibold text-xl text-ivory m-0">What you get</h2>
            <p className="mt-3 text-sm text-sage leading-relaxed m-0">
              A free plain 300ml Gold Sea Moss Gel on a future paid order — simple, fresh, and easy to share.
            </p>
          </section>

          <section className="rounded-xl border border-white/12 bg-panel/80 px-5 py-5">
            <h2 className="font-sans font-semibold text-base text-ivory m-0">Small print</h2>
            <p className="mt-2 text-xs text-sage/85 leading-relaxed m-0">{r.terms}</p>
          </section>
        </div>

        <div className="flex flex-wrap gap-3 mb-12">
          <Link to="/shop" className={`${HOME_CTA_DARK_PRIMARY} px-8 py-3.5 text-sm`}>
            Shop Gold Sea Moss
          </Link>
          <Link to="/#choose-sea-moss" className={`${HOME_CTA_DARK_OUTLINE} px-8 py-3.5 text-sm`}>
            Choose your sea moss
          </Link>
        </div>

        <WellnessDisclaimer />
      </ContentPageLayout>
    </SiteShell>
  );
}
